import React, {
	Component,
	PropTypes
} from 'react';
import { closeStepsDepositflow, confDepositPaymentNb as conf } from './../payment/common/lib/utils/router-config.js';
import navDeposit from './../payment/navdeposit/index.js';
import payment from './../payment/payment/index.js';

class DepositPaymentNB extends Component {
	componentWillMount() {
		const { push } = this.props.history;
		closeStepsDepositflow({
			bonus: true,
			pendingwithdrawals: true,
			payment: false,
			depositResult: true
		});
		navDeposit.init(conf);
		payment.init({
			wrapElmSelector: '#js-deposit-action',
			textkeys: conf.textkeys.selector,
			ageverifycb() {
				payment.close();
				navDeposit.close();
				push('/account/upload/age-verify');
			},
			agedontverifycb() {
				payment.close();
				navDeposit.close();
				push('/account');
			},
			compliancedontverifycb() {
				//navDeposit.close();
				//push('/account');
			}
		});
	}

	componentWillUnmount() {

	}

	render() {
		return (
			<div id="deposit-payment-nb" />
		);
	}
}
DepositPaymentNB.propTypes = {
	history: PropTypes.object
};
export default DepositPaymentNB;



// WEBPACK FOOTER //
// ./mobile-core/src/components/deposit-payment-nb.js